/* FEMILY product color tone presentation.
   Defaults remain untouched unless a verified product/variant record exists. */
(function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-femily-fold-facts]'));
  var DATA_URL = roots[0] && roots[0].getAttribute('data-femily-tone-map-url');
  var CSS_URL = roots[0] && roots[0].getAttribute('data-femily-tone-css-url');
  var toneDataPromise;

  function normalizeId(value) {
    return String(value || '').split('/').pop();
  }

  function loadCss() {
    if (!CSS_URL || document.querySelector('link[data-femily-color-tone-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = CSS_URL;
    link.setAttribute('data-femily-color-tone-css', '');
    document.head.appendChild(link);
  }

  function loadToneData() {
    if (toneDataPromise) return toneDataPromise;
    if (!DATA_URL) return Promise.resolve(null);
    toneDataPromise = fetch(DATA_URL, { credentials: 'same-origin', cache: 'force-cache' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
    return toneDataPromise;
  }

  function selectedVariantId(root) {
    var field = root.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('.t4s-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    return normalizeId(field && field.value);
  }

  function variantRows(row) {
    if (row._femilyVariantRows) return row._femilyVariantRows;
    var node = row.querySelector('[data-femily-color-variants]');
    try { row._femilyVariantRows = JSON.parse(node ? node.textContent : '[]'); }
    catch (error) { row._femilyVariantRows = []; }
    return row._femilyVariantRows;
  }

  function validPhotoUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      return url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.cdn.shopify.com')) ? url.href : '';
    } catch (error) { return ''; }
  }

  function makeSample(sample, selectedLabel) {
    var item = document.createElement('div');
    item.className = 'femily-color-tone__sample';
    if (sample.label === selectedLabel) {
      item.classList.add('is-current');
      item.setAttribute('aria-current', 'true');
    }

    var swatch = document.createElement('span');
    swatch.className = 'femily-color-tone__swatch';
    swatch.setAttribute('aria-hidden', 'true');
    swatch.style.setProperty('--femily-tone-swatch', sample.hex);
    item.appendChild(swatch);

    var copy = document.createElement('span');
    copy.className = 'femily-color-tone__sample-copy';
    var name = document.createElement('span');
    name.textContent = sample.label;
    copy.appendChild(name);
    if (sample.label === selectedLabel) {
      var current = document.createElement('span');
      current.className = 'femily-color-tone__current-label';
      current.textContent = 'Cor desta versão';
      copy.appendChild(current);
    }
    item.appendChild(copy);
    return item;
  }

  function makePanel(entry, variantId) {
    var imageUrl = validPhotoUrl(entry.photo);
    var samples = Array.isArray(entry.comparisons) ? entry.comparisons.filter(function (sample) {
      return sample && typeof sample.label === 'string' && /^#[0-9a-f]{6}$/i.test(sample.hex || '');
    }) : [];
    if (!imageUrl || samples.length < 2) return null;

    var panel = document.createElement('div');
    panel.id = 'femily-color-tone-panel-' + variantId;
    panel.className = 'femily-color-tone__panel';
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Comparação de tonalidades');

    var heading = document.createElement('h3');
    heading.className = 'femily-color-tone__heading';
    heading.textContent = 'Comparação de tonalidades';
    panel.appendChild(heading);

    var photo = document.createElement('img');
    photo.className = 'femily-color-tone__photo';
    photo.src = imageUrl;
    photo.alt = 'Foto desta bolsa na tonalidade ' + entry.label;
    photo.loading = 'lazy';
    photo.decoding = 'async';
    panel.appendChild(photo);

    var list = document.createElement('div');
    list.className = 'femily-color-tone__samples';
    samples.slice(0, 3).forEach(function (sample) {
      list.appendChild(makeSample(sample, entry.label));
    });
    panel.appendChild(list);

    var note = document.createElement('p');
    note.className = 'femily-color-tone__note';
    note.textContent = 'Amostras digitais de referência. A iluminação e a tela podem alterar a percepção da cor.';
    panel.appendChild(note);
    return panel;
  }

  function clearEnhancement(row, label, value, genericColor) {
    label.textContent = row.getAttribute('data-femily-original-label') || label.textContent;
    value.textContent = genericColor || value.getAttribute('data-default-color') || value.textContent;
    row.classList.remove('femily-pdp-trust__item--tone');
    var toggle = row.querySelector('.femily-color-tone__toggle');
    var panel = row.querySelector('.femily-color-tone__panel');
    if (toggle) toggle.remove();
    if (panel) panel.remove();
  }

  function renderRoot(root, data) {
    if (!root || !data || !data.variants) return;
    var variantId = selectedVariantId(root);
    var rows = root.querySelectorAll('[data-femily-color-row]');
    rows.forEach(function (row) {
      var label = row.querySelector('[data-femily-color-label]');
      var value = row.querySelector('[data-femily-fold-color]');
      if (!label || !value) return;
      if (!row.hasAttribute('data-femily-original-label')) {
        row.setAttribute('data-femily-original-label', label.textContent.trim());
      }

      var variantList = variantRows(row);
      if (!variantId && variantList.length) variantId = normalizeId(variantList[0].id);
      var generic = (variantList.filter(function (item) {
        return normalizeId(item.id) === variantId;
      })[0] || variantList[0] || {}).color;
      if (!generic) generic = value.getAttribute('data-default-color') || value.textContent.trim();

      var entry = data.variants[variantId];
      var signature = variantId + '|' + (entry && entry.label || 'generic');
      if (row.getAttribute('data-femily-tone-rendered') === signature) return;
      row.setAttribute('data-femily-tone-rendered', signature);

      if (!entry || !entry.label) {
        clearEnhancement(row, label, value, generic);
        return;
      }

      var fullLabel = entry.label;
      if (entry.undertone) fullLabel += ' · subtom ' + entry.undertone;
      label.textContent = 'Cor e tonalidade';
      value.textContent = fullLabel;
      row.classList.add('femily-pdp-trust__item--tone');

      var toggle = row.querySelector('.femily-color-tone__toggle');
      var panel = row.querySelector('.femily-color-tone__panel');
      if (toggle) toggle.remove();
      if (panel) panel.remove();

      var comparison = makePanel(entry, variantId);
      if (!comparison) return;

      toggle = document.createElement('button');
      toggle.className = 'femily-color-tone__toggle';
      toggle.type = 'button';
      toggle.textContent = 'Entenda a tonalidade desta bolsa';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', comparison.id);
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        comparison.hidden = isOpen;
      });
      row.appendChild(toggle);
      row.appendChild(comparison);
    });
  }

  function init() {
    roots.forEach(function (root) {
      root.hidden = false;
      loadCss();
    });
    loadToneData().then(function (data) {
      if (!data) return;
      roots.forEach(function (root) { renderRoot(root, data); });
    });

    var schedule = function () {
      window.setTimeout(function () {
        loadToneData().then(function (data) {
          roots.forEach(function (root) { renderRoot(root, data); });
        });
      }, 0);
    };
    document.addEventListener('change', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variant:changed', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
